module.exports = __webpack_public_path__ + "img/microsoft.d6893fae.svg";